module.exports = __webpack_public_path__ + "img/writing-blank.558392a.jpg";